import React from 'react';
import { LinkComponent as Link } from '../../../form/elements/link';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import css from './index.module.css';

interface Props {
  linkTo: string;
}

export function DefaultTableTopbar({ linkTo }: Props) {
  return (
    <div className={css['toolbar']}>
      <Link label="add" primary={true} linkTo={linkTo} icon={faPlus} />
    </div>
  );
}

export default function useDefaultTableTopbar(linkTo: string): [JSX.Element] {
  const defaultTableTopbar = <DefaultTableTopbar linkTo={linkTo} />;

  return [defaultTableTopbar];
}
